import { Component, OnInit, Input } from '@angular/core';
import { Faq, ParolaChiave } from '@hm_app/@core/models/info';
import * as _ from 'lodash';
import { FaqPerParolaChiaveComponent } from '../faq-per-parola-chiave/faq-per-parola-chiave.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BASE_PATH_IMAGES } from '@src/environments/configs';

@Component({
    selector: 'faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.scss'],
})
export class FaqComponent implements OnInit {

    @Input() faqs: Faq[];
    @Input() all_faqs: Faq[];
    @Input() parole_chiave: ParolaChiave[];

    _current_faq: Faq;
    current_parole_chiave: ParolaChiave[];

    BASE_PATH: string = BASE_PATH_IMAGES;

    constructor(private modalService: NgbModal) {

    }

    ngOnInit() {
    }

    set current_faq(cf: Faq) {
        this._current_faq = cf;
        this.current_parole_chiave = _.filter(this.parole_chiave, { informazione: cf.id });
    }

    get current_faq(): Faq {
        return this._current_faq;
    }

    filterForParolaChiave(p: ParolaChiave) {
        const keywords = _.filter(this.parole_chiave, function (k) {
            if (k.parolachiave.it == p.parolachiave.it) return k;
        });
        let faqs_for_keyword = [];
        for (const k of keywords) {
            const ffk = _.find(this.all_faqs, f => f.informazione == k.id);
            if (ffk) faqs_for_keyword.push(ffk);
        }
        faqs_for_keyword = _.sortBy(faqs_for_keyword, 'id');
        const modal = this.modalService.open(FaqPerParolaChiaveComponent, { size: 'lg' });
        modal.componentInstance.faqs = faqs_for_keyword;
        modal.componentInstance.parole_chiave = this.parole_chiave;
        modal.componentInstance.keyword = p.parolachiave;
    }

}
